import { SagaIterator } from 'redux-saga';
import { call } from 'redux-saga/effects';
import { SearchResultItem } from '@xiag-search/sdk';
import { logError } from 'src/sagas/utils/logError';
import { SearchResultEvent, SearchResultSectionType } from 'src/state/SearchResult';
import { getCustomFieldString } from 'src/utils/getCustomFieldString';
import { getCustomFieldDate } from 'src/utils/getCustomFieldDate';
import { getItemSectionType } from 'src/utils/getItemSectionType';
import { getItemDesignVariant } from 'src/utils/getItemDesignVariant';

export function* searchResolverEvent(searchItem: SearchResultItem): SagaIterator {
    try {
        const objectType = searchItem.customFields['object-type'];
        if (objectType !== 'event') {
            return null;
        }

        const sectionType: SearchResultSectionType = yield call(getItemSectionType, searchItem);
        const eventItem: SearchResultEvent = {
            id: searchItem.trackId,
            displayType: 'event',
            designVariant: yield call(getItemDesignVariant, searchItem),
            sectionType,
            searchItem,
            eventLocation: yield call(getCustomFieldString, searchItem.customFields['object-city']),
            eventStartDate: yield call(getCustomFieldDate, searchItem.customFields['object-startdate']),
            eventEndDate: yield call(getCustomFieldDate, searchItem.customFields['object-enddate']),
        };
        return eventItem;
    } catch (error) {
        yield call(logError, 'Could not process event item', { error, searchItem });
        return null;
    }
}
